/** Phase 13 — Stage badge color tokens (uses semantic design system tokens). */
export type Stage = 'none' | 'suggestion' | 'prefill' | 'job_suggestion' | 'automation' | string;

export function stageBadgeClass(stage: Stage): string {
  switch (stage) {
    case 'automation':
      return 'bg-primary/15 text-primary border-primary/30';
    case 'job_suggestion':
      return 'bg-accent/15 text-accent-foreground border-accent/30';
    case 'prefill':
      return 'bg-secondary text-secondary-foreground border-border';
    case 'suggestion':
      return 'bg-muted text-foreground border-border';
    default:
      return 'bg-muted/40 text-muted-foreground border-border';
  }
}

export function stageLabel(stage: Stage): string {
  switch (stage) {
    case 'automation': return 'Automation';
    case 'job_suggestion': return 'Job Suggestion';
    case 'prefill': return 'Prefill';
    case 'suggestion': return 'Suggestion';
    case 'none': return 'Insufficient';
    default: return stage;
  }
}

export function pct(n: number | null | undefined, digits = 1): string {
  if (n == null || Number.isNaN(n)) return '—';
  return `${(n * 100).toFixed(digits)}%`;
}
